import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = '/api';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('anise_token');
    const tenantId = localStorage.getItem('anise_tenant_id');
    const email = localStorage.getItem('anise_email');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser({ token, tenantId, email });
    }
    setLoading(false);

    // Global 401 interceptor — only clear session on auth/copilot 401s,
    // not on admin endpoint 401s (those are expected for non-admin users)
    const interceptor = axios.interceptors.response.use(
      res => res,
      err => {
        if (err.response?.status === 401) {
          const url = err.config?.url || '';
          const isAdminEndpoint = url.includes('/admin/');
          if (!isAdminEndpoint) {
            localStorage.removeItem('anise_token');
            localStorage.removeItem('anise_tenant_id');
            localStorage.removeItem('anise_email');
            delete axios.defaults.headers.common['Authorization'];
            setUser(null);
          }
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, tenant_id } = res.data;
    localStorage.setItem('anise_token', access_token);
    localStorage.setItem('anise_tenant_id', tenant_id);
    localStorage.setItem('anise_email', email);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setUser({ token: access_token, tenantId: tenant_id, email });
  };

  const logout = () => {
    localStorage.removeItem('anise_token');
    localStorage.removeItem('anise_tenant_id');
    localStorage.removeItem('anise_email');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
